import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import dataService from "../../../../../helpers/dataService";
import Loader from "../../../../common/Loader";
import EpRecipientsList from "./EpRecipientsList";
import EpRecipientsStats from "./EpRecipientsStats";

const EpRecipientsV2 = ({ ep, onRefreshCalendar }) => {
  const [recipients, setRecipients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({});

  const fetchRecipients = () => {
    if (!ep.id) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    // MOCK TEMPORAIRE - À RETIRER QUAND L'API SERA PRÊTE
    // const mockData = [
    //   {
    //     id: "mock-inscription-1",
    //     type: "SUSPENSION",
    //     motif: "REFUS_OFFRE_RAISONNABLE_EMPLOI",
    //     pathType: "PROFESSIONNEL",
    //     secondaryReasons: [
    //       "DIFFICULTES_LIEES_A_LA_SANTE",
    //       "FAMILLE_AVEC_ENFANTS_EN_BAS_AGE",
    //     ],
    //     organizationOrigin: "5fdcd91d22c568001b280c36",
    //     selectedProposal: "DEFAUT",
    //     proposalPercent: 50,
    //     proposalDuration: 2,
    //     pregnancy: true,
    //     detectionType: "PREMIER",
    //     userRecipient: {
    //       userRecipientRef: "recipient",
    //       id: "65d35dd3a3d3d2001b9bba12",
    //       fullname: "Mme DUPONT Marie",
    //       nir: "2850123456789",
    //       age: "67 ans",
    //       sddStatus: "SDD",
    //       maritalStatusLabel: "Mariée",
    //       rsaTypeLabel: "RSA Socle",
    //       city: "Saint-Pierre",
    //       postalCode: "97410",
    //       orientationPartner: "MISSION LOCALE SUD",
    //       nbChildrenOrDependant: 2,
    //     },
    //     createdAt: "2025-01-15T10:30:00.000Z",
    //     updatedAt: "2025-01-20T14:45:00.000Z",
    //   },
    // ];

    // setTimeout(() => {
    //   setRecipients(mockData);
    //   setIsLoading(false);
    // }, 500);

    // CODE RÉEL - DÉCOMMENTER QUAND L'API SERA PRÊTE
    dataService.get(
      `eps/${ep.id}/lister-inscriptions`,
      (data) => {
        setRecipients(Array.isArray(data) ? data : []);
        setIsLoading(false);
      },
      (err) => {
        setErrors(err);
        setIsLoading(false);
      },
    );
  };

  useEffect(() => {
    fetchRecipients();
  }, [ep.id]);

  const handleDelete = (inscriptionId) => {
    dataService.remove(
      `inscriptions-ep/${inscriptionId}`,
      {},
      () => {
        setRecipients((prev) => prev.filter((r) => r.id !== inscriptionId));
        toast.success("Inscription supprimée avec succès");
        if (onRefreshCalendar) onRefreshCalendar();
        fetchRecipients();
      },
      (err) => {
        toast.error(
          err?.other || "Erreur lors de la suppression de l'inscription",
        );
      },
    );
  };

  if (isLoading) {
    return (
      <div className="text-center p-5">
        <Loader />
        <p className="mt-3 text-muted">
          Chargement des allocataires inscrits...
        </p>
      </div>
    );
  }

  if (Object.keys(errors).length > 0) {
    return (
      <div className="alert alert-danger m-4">
        <i className="fa fa-exclamation-triangle mr-2" />
        <strong>Erreur lors du chargement des allocataires</strong>
        <p className="mb-0 mt-2">{Object.values(errors).join(", ")}</p>
      </div>
    );
  }

  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <p className="text-muted mb-0" style={{ fontSize: 14 }}>
            {recipients.length} allocataire{recipients.length > 1 ? "s" : ""}{" "}
            inscrit{recipients.length > 1 ? "s" : ""}
          </p>
        </div>
      </div>

      <EpRecipientsStats recipients={recipients} />

      <EpRecipientsList
        recipients={recipients}
        onDelete={handleDelete}
        disabled={ep.startedAt ? true : false}
        onUpdateRecipient={(id, updatedFields) =>
          setRecipients((prev) =>
            prev.map((r) => (r.id === id ? { ...r, ...updatedFields } : r)),
          )
        }
      />
    </div>
  );
};

export default EpRecipientsV2;
